import React from 'react';
import styles from './index.module.scss';

export const SupportLink = () => {
  return (
    <div className="flex flex-col">
      <span className="pb-2">In case you need additional help, feel free to</span>
      <a href="mailto:support@onestep.co" target="_blank" className={styles.link}>
        Contact Support
      </a>
    </div>
  );
};
